import { compact } from "lodash";
import React from "react";
import classNames from "../utils/classNames";

interface Props {
  className?: string;
  title?: string;
  paragraphs?: any[];
}

const FeatureExplanation: React.FC<Props> = ({
  className,
  title,
  paragraphs = [],
  children
}) => (
  <div
    className={classNames(
      "my-4 mx-4 sm:my-10 sm:mx-10 dark:text-white",
      className
    )}
  >
    {title && (
      <h1 className="mb-6 text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl dark:text-gray-50">
        {title}
      </h1>
    )}
    {compact(paragraphs).map((paragraph, index) => (
      <p
        key={index}
        className="mt-2 text-base text-gray-500 dark:text-gray-300"
      >
        {paragraph}
      </p>
    ))}
    {children}
  </div>
);

export default FeatureExplanation;
